import { render } from "./Footer.vue?vue&type=template&id=b34767c4&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b34767c4"

export default script